import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Arranger from '~/client/components/base/arranger';
import { ButtonProps } from '~/client/components/base/button';
import { spc } from '~/client/components/base/spacer';

interface Props extends ButtonProps {
  className?: string;
  /**
   * One or more `<Button/>` elements to render
   */
  children?: React.ReactNode;
}

const TableActionImpl: React.FC<Props> = ({
  className,
  children,
  ...props
}) => {
  // Unwrap React Fragments
  if (React.isValidElement(children) && children.type === React.Fragment) {
    return (
      <TableActionImpl
        className={className}
        {...props}
        children={children.props.children}
      />
    );
  }

  return (
    <Arranger
      className={className}
      justify="flex-end"
      // sx={{ mt: spc.xxs }}
    >
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, props);
        }
      })}
    </Arranger>
  );
};

/**
 * A components that is meant to be used within `<TableRow/>`.
 *
 * When used within `<TableRow/>`, it renders the elements in the last
 * column of the given row.
 *
 * `<TableAction/>` should only contain `<Button/>` elements as children. It
 * accepts all button props, and will pass them through to all its
 * button children.
 */
export const TableAction = muiStyled(TableActionImpl)(({ theme }) => {
  const gap = theme.spacing(spc.xxs);

  return css`
    gap: ${gap};
  `;
});

// This is required for `<Table/>` component to recognize TableAction element
TableAction.displayName = 'TableAction';
